<ng-template #incidentsMenu>
    <div style="display: flex; flex-direction: column; height: 100%">
        <div style="flex: 1">
            <mat-tree
                [dataSource]="leftMenuDataSource"
                [treeControl]="treeControl"
                style="background: transparent"
            >
                <!-- leaf node -->
                <mat-tree-node
                    *matTreeNodeDef="let node"
                    matTreeNodePadding
                    matTreeNodePaddingIndent="15px"
                    style="color: white"
                    class="menuItem"
                >
                    @if (!node.children && node.level === 0) {
                        <button
                            mat-icon-button
                            disabled
                            [attr.data-uiid]="'incident-overview-left-menu-icon-' + node.preset?.id"
                        ></button>
                    }

                    <span
                        [matTooltip]="node.name"
                        matTooltipClass="cerrix-tooltip"
                        matTooltipShowDelay="300"
                    >
                        <button
                            mat-button
                            [disabled]="
                                node.preset && !!node.preset && node.preset.id === activePresetId
                            "
                            [color]="
                                node.preset && !!node.preset && node.preset.id === activePresetId
                                    ? 'gray'
                                    : 'white'
                            "
                            [attr.data-uiid]="
                                'incident-overview-left-menu-button-' + node.preset?.id
                            "
                            (click)="leftMenuAction(node)"
                        >
                            @if (node.preset) {
                                <mat-icon style="margin-right: 0.2rem">
                                    {{ node.preset.icon }}
                                </mat-icon>
                            }
                            {{ node.name }}
                        </button></span
                    >
                </mat-tree-node>

                <!-- expandable nodes -->
                <mat-tree-node
                    *matTreeNodeDef="let node; when: hasChild"
                    matTreeNodePadding
                    matTreeNodePaddingIndent="15px"
                    style="color: white"
                    class="menuItem"
                    isExpanded
                >
                    <button
                        mat-icon-button
                        matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.name"
                        [attr.data-uiid]="'incident-overview-left-menu-toggle-' + node.id"
                        [color]="'white'"
                    >
                        <mat-icon>
                            {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
                        </mat-icon>
                    </button>
                    @if (node.icon) {
                        <mat-icon style="margin-right: 0.2rem">
                            {{ node.icon }}
                        </mat-icon>
                    }
                    {{ node.name }}
                </mat-tree-node>
            </mat-tree>
        </div>
    </div>
</ng-template>

<div class="incident-overview-container">
    @if (isReporter) {
        <div class="actions-top-bar">
            <div class="left-panel">
                <cerrix-button
                    [dataUiid]="'incident-overview-add-new-button'"
                    color="primary"
                    size="medium"
                    (click)="addIncident()"
                ><mat-icon fontSet="material-symbols-outlined">add</mat-icon
                ><ng-container>{{ 'incident.addNewIncident' | transloco }}</ng-container></cerrix-button
                >
            </div>
        </div>
    }

    <div class="filter-top-bar">
        <div class="left-panel">
            <mat-form-field class="search-filter-container">
                <mat-label>{{ 'incident.searchFilterLabel' | transloco }}</mat-label>
                <input
                    matInput
                    type="text"
                    [attr.data-uiid]="'incident-overview-search-input'"
                    [(ngModel)]="searchValue"
                    (input)="onSearch(false)"
                    (keydown.enter)="onSearch(true)"
                />
                @if (searchValue) {
                    <button matSuffix mat-icon-button (click)="onClearSearch()">
                        <mat-icon>close</mat-icon>
                    </button>
                }
            </mat-form-field>

            <button
                [disabled]="!preset && activePresetId"
                [attr.data-uiid]="'incident-overview-preset-button'"
                (click)="onPresetConfig()"
                mat-stroked-button
            >
                @if (preset || activePresetId) {
                    {{ 'incident.editPreset' | transloco }}
                } @else {
                    {{ 'incident.addPreset' | transloco }}
                }
                @if (preset && hasPresetChanges) {
                    <mat-icon iconPositionEnd color="warn">save</mat-icon>
                }
            </button>
        </div>
        <div class="right-panel">
            <mat-divider class="divider" [vertical]="true"></mat-divider>
            <cerrix-icon-button
                [dataUiid]="'incident-overview-export-button'"
                [tooltipContent]="'incident.exportTooltip' | transloco"
                [disabled]="!incidents?.length || loadingIncidents"
                (click)="exportIncidents()"
            >
                <mat-icon fontSet="material-symbols-outlined">download</mat-icon>
            </cerrix-icon-button>
        </div>
    </div>

    <div class="table-container">
        @if (loadingIncidents || loadingHeaders) {
            <div class="loading-spinner">
                <mat-spinner></mat-spinner>
            </div>
        }

        <div class="table-content">
            @if (headers.size) {
                <table
                    mat-table
                    [dataSource]="incidents"
                    matSort
                    [matSortActive]="sortActive"
                    [matSortDirection]="sortDirection"
                    (matSortChange)="onSortChange($event)"
                >
                    <ng-container matColumnDef="Classification">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-classification'"
                        >
                            {{ incidentColumnsTranslation.get("Classification") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.classification"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.classification }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Organization">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-organization'"
                        >
                            {{ incidentColumnsTranslation.get("Organization") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.organization"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.organization }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ReportedBy">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-reportedby'"
                        >
                            {{ incidentColumnsTranslation.get("ReportedBy") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.reportedBy"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.reportedBy }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="CompletedBy">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-completedby'"
                        >
                            {{ incidentColumnsTranslation.get("CompletedBy") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.completedBy"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.completedBy }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentStatus">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-incidentstatus'"
                        >
                            {{ incidentColumnsTranslation.get("IncidentStatus") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="incidentStatus[element.incidentStatus]"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.incidentStatusTranslation }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Name">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-name'"
                        >
                            {{ incidentColumnsTranslation.get("Name") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.name"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.name }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Identifier" sticky>
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-identifier'"
                        >
                            {{ incidentColumnsTranslation.get("Identifier") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.identifier"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.identifier }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Description">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-description'"
                        >
                            {{ incidentColumnsTranslation.get("Description") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.description"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.description }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="OccurredOn">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-occurredon'"
                        >
                            {{ incidentColumnsTranslation.get("OccurredOn") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.occurredOn | dateTimeDisplay"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.occurredOn | dateTimeDisplay }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="DetectedOn">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-detectedon'"
                        >
                            {{ incidentColumnsTranslation.get("DetectedOn") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.detectedOn | dateTimeDisplay"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.detectedOn | dateTimeDisplay }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="CreatedOn">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-createdon'"
                        >
                            {{ incidentColumnsTranslation.get("CreatedOn") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.createdOn | dateTimeDisplay"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.createdOn | dateTimeDisplay }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ClosedOn">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-closedon'"
                        >
                            {{ incidentColumnsTranslation.get("ClosedOn") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.closedOn | dateTimeDisplay"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.closedOn | dateTimeDisplay }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="DueDate">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-duedate'"
                        >
                            {{ incidentColumnsTranslation.get("DueDate") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.dueDate | dateTimeDisplay"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.dueDate | dateTimeDisplay }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="RootCause">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-rootcause'"
                        >
                            {{ incidentColumnsTranslation.get("RootCause") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.rootCause"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.rootCause }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="InternalIdentifier">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="
                                'incident-overview-header-cell-internalidentifier'
                            "
                        >
                            {{ incidentColumnsTranslation.get("InternalIdentifier") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.internalIdentifier"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.internalIdentifier }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Impact">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            disableClear
                            [attr.data-uiid]="'incident-overview-header-cell-impact'"
                        >
                            {{ incidentColumnsTranslation.get("Impact") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.impact"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.impact }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentTypes">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            [attr.data-uiid]="'incident-overview-header-cell-incidenttypes'"
                        >
                            {{ incidentColumnsTranslation.get("IncidentTypes") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.incidentTypes"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.incidentTypes }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentBusinessDimensions">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            [attr.data-uiid]="
                                'incident-overview-header-cell-incidentbusinessdimensions'
                            "
                        >
                            {{ incidentColumnsTranslation.get("IncidentBusinessDimensions") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.businessDimensions"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.businessDimensions }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentFrameworkDimensions">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            [attr.data-uiid]="
                                'incident-overview-header-cell-incidentframeworkdimensions'
                            "
                        >
                            {{ incidentColumnsTranslation.get("IncidentFrameworkDimensions") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.frameworkDimensions"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.frameworkDimensions }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentRootCauseCategories">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            [attr.data-uiid]="
                                'incident-overview-header-cell-rootcausecategories'
                            "
                        >
                            {{ incidentColumnsTranslation.get("IncidentRootCauseCategories") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.rootCauseCategories"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.rootCauseCategories }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentCausedByOrganizations">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            [attr.data-uiid]="
                                'incident-overview-header-cell-causedbyorganizations'
                            "
                        >
                            {{
                                incidentColumnsTranslation.get("IncidentCausedByOrganizations")
                            }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.causedByOrganizations"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.causedByOrganizations }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentAffectedOrganizations">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            [attr.data-uiid]="
                                'incident-overview-header-cell-incidentaffectedorganizations'
                            "
                        >
                            {{
                                incidentColumnsTranslation.get("IncidentAffectedOrganizations")
                            }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.affectedOrganizations"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.affectedOrganizations }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentCausedByThirdParties">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            [attr.data-uiid]="
                                'incident-overview-header-cell-causedbythirdparties'
                            "
                        >
                            {{ incidentColumnsTranslation.get("IncidentCausedByThirdParties") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.causedByThirdParties"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.causedByThirdParties }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentAffectedThirdParties">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            [attr.data-uiid]="
                                'incident-overview-header-cell-incidentaffectedthirdparties'
                            "
                        >
                            {{ incidentColumnsTranslation.get("IncidentAffectedThirdParties") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.affectedThirdParties"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.affectedThirdParties }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentResponsibles">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            [attr.data-uiid]="
                                'incident-overview-header-cell-IncidentResponsibles'
                            "
                        >
                            {{ incidentColumnsTranslation.get("IncidentResponsibles") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.responsibles"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.responsibles }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentAssessors">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            [attr.data-uiid]="'incident-overview-header-cell-IncidentAssessors'"
                        >
                            {{ incidentColumnsTranslation.get("IncidentAssessors") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.assessors"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.assessors }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="IncidentInformed">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            [attr.data-uiid]="'incident-overview-header-cell-IncidentInformed'"
                        >
                            {{ incidentColumnsTranslation.get("IncidentInformed") }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [matTooltip]="element.informed"
                            [matTooltipShowDelay]="tooltipDelay"
                        >
                            {{ element.informed }}
                        </td>
                    </ng-container>

                    @for (header of customFieldHeaders; track header) {
                        <ng-container [matColumnDef]="header.name">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                                [disabled]="
                                    header.fieldType === FieldType.MultiSelect ||
                                    header.fieldType === FieldType.FinancialImpact
                                "
                                disableClear
                                [attr.data-uiid]="
                                    'incident-overview-header-cell-cf-' + header.name
                                "
                            >
                                {{ header.translation }}
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                [matTooltip]="
                                    incidentsCustomFields.get(element.id + header.name)
                                "
                                [matTooltipShowDelay]="tooltipDelay"
                            >
                                {{ incidentsCustomFields.get(element.id + header.name) }}
                            </td>
                        </ng-container>
                    }

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns; let i = index"
                        [attr.data-uiid]="'incident-overview-row-' + i"
                        (click)="openIncident(row)"
                    ></tr>

                    <tr *matNoDataRow>
                        @if (!loadingIncidents) {
                            <td
                                class="no-data-cell"
                                [attr.data-uiid]="'incidents-overview-no-data-label'"
                                [attr.colspan]="displayedColumns?.length"
                            >
                                {{ 'incident.noDataMatchingFilter' | transloco }}
                            </td>
                        }
                    </tr>
                </table>
            }
        </div>

        @if (headers.size) {
            <mat-paginator
                [length]="totalIncidents"
                [pageIndex]="pageIndex"
                [pageSize]="pageSize"
                [pageSizeOptions]="[10, 25, 50, 100]"
                showFirstLastButtons
                (page)="onPageEvent($event)"
            ></mat-paginator>
        }
    </div>
</div>
